<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          <span>
            Action log
          </span>
        </v-card-title>
        <v-card-text>
					<v-row>
						<v-col>
							<validation-provider
								v-slot="{ errors }"
								rules="required"
								slim
								name="serverIds"
							>
								<v-select
									v-model="serverId"
									:items="servers"
									item-text="description"
									item-value="id"
									:error-messages="errors"
								/>
							</validation-provider>
						</v-col>
						<v-col class="pt-7">
							<date-picker
								v-model="date"
								hide-details
								dense
								label="Date"
							></date-picker>
						</v-col>
						<v-col class="pt-7">
							<v-btn color="success" @click="fetchActionLog">
								Buscar
							</v-btn>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-data-table
								:loading="loading"
								:headers="table.columns"
								:items="logs">
							</v-data-table>
						</v-col>
					</v-row>
        </v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import { ValidationProvider, extend } from "vee-validate";
import ContentLoader from "../../../mixins/ContentLoader.js";
import { fetchActionLogs, fetchActionLogParams } from "../../../../api/actionLog.api";
import { required } from "vee-validate/dist/rules.js";
import DatePicker from "../../../components/inputs/DatePicker.vue";

extend("required", {
	...required,
	message: "This field is required"
});

export default {
  name: "ActionLogIndex",
  mixins: [ContentLoader],
	components: {
  	ValidationProvider,
		DatePicker
	},
  data() {
    return {
      logs: [],
			serverId: null,
			servers: [],
			date: (new Date(Date.now())).toISOString().split('T')[0],
      table: {
        columns: [
          {
            text: "User",
            value: "user.username"
          },
          {
            text: "Description",
            value: "description"
          },
					{
						text: "Date",
						value: 'date'
					},
          {
            text: "Data",
            value: "extraData"
          }
        ]
      }
    };
  },
  mounted() {
  	this.fetchParams()
  },
  methods: {
    async fetchActionLog() {
      this.$startLoading();
      try {
        const response = await fetchActionLogs(this.serverId, this.date);
        this.logs = response.data.logs;

        await this.$nextTick();
      } catch (e) {
        console.error(e);
      } finally {
        this.$finishedLoading();
      }
    },
		async fetchParams() {
			this.$startLoading();
			try {
				const response = await fetchActionLogParams();
				this.servers = response.data.servers;
				await this.$nextTick();
			} catch (e) {
				console.error(e);
			} finally {
				this.$finishedLoading();
			}
		}
	}
};
</script>

<style scoped></style>
